import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import FejezetEditService from 'app/admin/fejezet/service/FejezetEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = {
	key: 'fejezetEditForm',
	text: 'Fejezetek',
	textKey: 'fejezet',
	service: FejezetEditService,
	icon: 'person',
	fields: [
		{
			key: 'nev',
			text: 'Név',
			textKey: 'nev',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'sorszam',
			text: 'Sorszám',
			textKey: 'sorszam',
			component: EditFormTextField,
			type: 'number',
			required: true
		},
		{
			key: 'feladatCsoport',
			text: 'Feladatcsoport',
			textKey: 'feladatCsoport',
			component: EditFormSelectField,
			required: true,
			items: () => FejezetEditService.getFeladatCsoportSelection()
		},
		{
			key: 'userGroup',
			text: 'Felhasználói csoport',
			component: EditFormSelectField,
			// multiple: true,
			items: () => UserGroupService.getListSelection()
		}
	]
};

function FejezetEditForm() {
	return <EditFormPage config={config} />;
}

export default FejezetEditForm;
